import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

const WINDOWS98_ICONS = new Set([
  "documents98-icon",
  "find98-icon",
  "favourites98-icon",
  "exe98-icon",
  "logoff98-icon",
  "programs98-icon",
  "run98-icon",
  "settings98-icon",
  "txt98-icon",
  "user98-icon",
  "key98-icon",
]);

@customElement("a2k-icon")
export class A2kIcon extends LitElement {
  // Preserve the original A2K icon sizing inside every component's shadow root.
  static styles = css`
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 2em;
    }
  `;

  @property() icon = "";
  render() {
    const sprite = WINDOWS98_ICONS.has(this.icon)
      ? "windows98-icons.svg"
      : "a2k-icons.svg";
    return html`<svg
      class="a2k-icon-svg"
      aria-hidden="true"
      width="1em"
      height="1em"
    >
      <use
        width="100%"
        height="100%"
        href=${`/static/core/assets/${sprite}#${this.icon}`}
      ></use>
    </svg>`;
  }
}
